import { render, staticRenderFns } from "./AddAgencyAtlassian.vue?vue&type=template&id=b07b1d7e"
import script from "./AddAgencyAtlassian.vue?vue&type=script&lang=js"
export * from "./AddAgencyAtlassian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports